import React from 'react'
import styled from 'styled-components'

import { RowFlexDiv, Icon } from '../Common/CommonStyle'
import ParentdirectoryLayout from './ParentDirectoryLayout'

import {
  NudistaMedium14,
  RobotoMedium14,
  NudistaMedium11,
  NudistaMedium9,
  NudistaSemiBold16,
  NudistaBold14,
  NudistaBoldCustomFont,
} from '../Common/Fonts'

const FolderView = ({
  thumbsviewNavbarMinified,
  title,
  backgroundColor,
  marginLeft,
  customWidth,
}) => {
  const [dropDown, setDropDown] = React.useState(false)
  return (
    <ColumnFlexDiv width='96%'>
      <RowFlexDiv
        padding='2%'
        marginTop='5px'
        justifyContent='flex-start'
        width={thumbsviewNavbarMinified ? '0px' : '100%'}
        opacity={thumbsviewNavbarMinified ? '0' : '1'}
        zIndex={thumbsviewNavbarMinified ? '-100' : '1'}
        backgroundColor={backgroundColor}
      >
        <RowFlexDiv
          height='20px'
          width='50%'
          justifyContent='flex-start'
          gap='3px'
          width={thumbsviewNavbarMinified ? '0px' : '40%'}
          opacity={thumbsviewNavbarMinified ? '0' : '1'}
          zIndex={thumbsviewNavbarMinified ? '-100' : '1'}
        >
          <Icon
            src='/images//mainView/assignmentsView/dropdown.svg'
            transform={dropDown ? 'rotate(0deg)' : 'rotate(270deg)'}
            background-color='#6a26ca'
            onClick={() => setDropDown(!dropDown)}
          />

          <Icon
            src='/images//mainView/assignmentsView/folder.svg'
            background-color='#6a26ca'
          />

          <NudistaMedium14>{title}</NudistaMedium14>
        </RowFlexDiv>
        <RowFlexDiv
          width={customWidth ? customWidth : '45%'}
          justifyContent='flex-end'
        >
          <RowFlexDiv
            height='20px'
            width='25px'
            opacity='0.38'
            justifyContent='center'
            borderRadius='6px'
            marginLeft='30px'
          >
            <NudistaMedium9> 1234</NudistaMedium9>
          </RowFlexDiv>
        </RowFlexDiv>
      </RowFlexDiv>
      {dropDown ? (
        <ColumnFlexDiv width={thumbsviewNavbarMinified ? '0px' : '100%'}>
          {/* list of directories starts from here */}
          <ParentdirectoryLayout
            thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          />
        </ColumnFlexDiv>
      ) : (
        <></>
      )}
    </ColumnFlexDiv>
  )
}
const ColumnFlexDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-overflow: ellipsis;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ zIndex }) => zIndex};
  overflow: ${({ overflow }) => overflow};
  gap: ${({ gap }) => gap};
  margin: ${({ margin }) => margin};
  margin-left: ${(props) => props.marginLeft};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
  padding: ${(props) => props.padding};
  position: ${(props) => props.position};
  background-color: ${(props) => props.backgroundColor};
  /* background-color: #123456; */
  justify-content: ${(props) => props.justifyContent};
  align-items: ${(props) => props.alignItems};
`

export default FolderView
